import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-settingsProgressBlock',
  templateUrl: './settings-progress-block.component.html'
})
export class SettingsProgressBlockComponent implements OnInit {

  @Input('TopLeft') topLeft: any;
  @Input('TopRight') topRight: any;
  @Input('BottomLeft') bottomLeft: any;
  @Input('BottomRight') bottomRight: any;
  @Input('Progress') progress: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

}